import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import { FiX } from "react-icons/fi";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import ProductEdit from "../../Views/ProductEdit";
import { setProductDialogState } from "../../Store/Modules/Dialogs/Actions";
import { Title } from "./styles";
import { Typography } from "@material-ui/core";

export default function EditProductDialog() {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width:769px)");
  const { editProductDialog } = useSelector((state) => state.dialogs);
  const categoryName = useSelector(
    (state) =>
      state.menu.menu.find((cat) =>
        cat.itens.find(
          (product) => product._id === editProductDialog.data.productId
        )
      )?.nameShow
  );

  function handleClose() {
    dispatch(setProductDialogState("show", false));
    dispatch(setProductDialogState("activeTab", 0));
    dispatch(setProductDialogState("data", {}));
  }

  function getContent() {
    return (
      <React.Fragment>
        <DialogTitle>
          <Title>
            Alterando produto {editProductDialog.data.printDescription} <br />
            <Typography variant="overline">{categoryName}</Typography>
          </Title>
          <Button
            style={{ position: "absolute", right: "10px", top: "10px" }}
            onClick={handleClose}
          >
            <FiX style={{ fontSize: "25px" }} />
          </Button>
        </DialogTitle>
        <DialogContent>
          <ProductEdit id={editProductDialog.data.productId} />
        </DialogContent>
      </React.Fragment>
    );
  }

  React.useEffect(() => {
  }, [editProductDialog]);

  return (
    <>
      {isMobile ? (
        <Dialog fullScreen onClose={handleClose} open={editProductDialog.show}>
          {getContent()}
        </Dialog>
      ) : (
        <Dialog
          fullScreen
          maxWidth="md"
          onClose={handleClose}
          open={editProductDialog.show}
        >
          {getContent()}
        </Dialog>
      )}
    </>
  );
}
